const data = {
    lines: [
        { columns: [
                { col: 'Batch 1' },
                { col: 'Jan. 11, 18, 25, Feb. 01, 08 & 15' },
                { col: 'Sucat, Parañaque City' },
                { col: '09:00-11:15am' },
                {},
                {}
            ]
        },
        { columns: [
                { col: 'Batch 2' },
                { col: 'Feb. 22, Mar. 01, 08, 15, 22 & 29' },
                { col: 'Sucat, Parañaque City' },
                { col: '09:00-11:15am' },
                {},
                {}
            ]
        },
        { columns: [
                { col: 'Batch 5' },
                { col: 'June 14, 21, 28, July 05, 12 & 19' },
                { col: 'Sucat, Parañaque City' },
                { col: '09:00-11:15am' },
                {},
                {}
            ]
        },
        { columns: [
                { col: 'Batch 6' },
                { col: 'July 26, Aug. 2, 09, 23, 30 & Sept. 06' },
                { col: 'Sucat, Parañaque City' },
                { col: '09:00-11:15am' },
                {},
                {}
            ]
        },
        { columns: [
                { col: 'Batch 7' },
                { col: 'Sept. 20, 27, Oct. 04, 11, 18 & 25' },
                { col: 'Sucat, Parañaque City' },
                { col: '09:00-11:15am' },
                {},
                {}
            ]
        },
        { columns: [
                { col: 'Batch 8' },
                { col: 'Nov. 8, 15, 22, 29, Dec. 06 & 13' },
                { col: 'Sucat, Parañaque City' },
                { col: '09:00-11:15am' },
                { col: 'Alabang - Starmall' },
                { col: '02:00-04:15pm' }
            ]
        }
    ]
}

export default data